import React, { createContext, useContext, useEffect, useState } from "react";
import { api, formatApiError } from "../lib/api";

const AdminAuthContext = createContext(null);

export const AdminAuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null); // null=checking, false=not auth, object=auth
  const token = localStorage.getItem("aarmira_admin_token");

  useEffect(() => {
    const check = async () => {
      if (!token) return setAdmin(false);
      try {
        const { data } = await api.get("/admin/me");
        setAdmin(data);
      } catch {
        localStorage.removeItem("aarmira_admin_token");
        setAdmin(false);
      }
    };
    check();
  }, [token]);

  const login = async (username, password) => {
    try {
      const { data } = await api.post("/admin/login", { username, password });
      localStorage.setItem("aarmira_admin_token", data.token);
      setAdmin({ username: data.username });
      return { ok: true };
    } catch (e) {
      return { ok: false, error: formatApiError(e.response?.data?.detail) };
    }
  };

  const logout = () => {
    localStorage.removeItem("aarmira_admin_token");
    setAdmin(false);
  };

  return (
    <AdminAuthContext.Provider value={{ admin, login, logout }}>
      {children}
    </AdminAuthContext.Provider>
  );
};

export const useAdminAuth = () => useContext(AdminAuthContext);
